// extracted by mini-css-extract-plugin
export default {"wrapper":"InputForm_wrapper__+1or0","icon":"InputForm_icon__N8iF+"};